module.exports = __webpack_public_path__ + "d9f581357e2fd48fc02fe40239a21f81.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/david-khourshid.jpg
 ** module id = 407
 ** module chunks = 0
 **/